import type { SidebarMenuItem } from '@nebula-layout/layout';
import { normalizeMenuLabelKey } from './vault-menu-labels';

/** Rutas con contenido real bajo Administrador (no eliminar). */
const ADMIN_FUNCTIONAL_ROUTE_PARTS = [
  '/admin/tenants',
  '/admin/user',
  '/admin/users',
  '/admin/module-permissions',
];

function normalizedRoute(item: SidebarMenuItem): string {
  return (item.route ?? '').toLowerCase().split('?')[0].split('#')[0];
}

function isAdminFunctionalRoute(route: string): boolean {
  return ADMIN_FUNCTIONAL_ROUTE_PARTS.some((p) => route.includes(p));
}

/**
 * Ítem lateral redundante: "Administrador" / `admin/dashboard` / `/admin` (placeholder).
 * Gestión de empresas y usuarios ya están como entradas propias.
 */
export function menuItemIsVaultAdminDashboardStub(item: SidebarMenuItem): boolean {
  if (item.children?.length) return false;

  const r = normalizedRoute(item);
  const lbl = normalizeMenuLabelKey(item.label ?? '').toLowerCase();

  if (r && isAdminFunctionalRoute(r)) return false;

  if (r.includes('/admin/dashboard')) return true;
  if (r && /\/admin\/?$/.test(r)) return true;

  if (lbl === 'admin dashboard' || lbl === 'panel de administracion') return true;

  if (lbl === 'administrador') {
    return !r || !isAdminFunctionalRoute(r);
  }

  const raw = (item.label ?? '').toLowerCase();
  if (/options vault admin/.test(raw) && !/tenant|user|permission|permis/.test(raw)) {
    return true;
  }

  return false;
}

/** Entrada lateral obsoleta: configuración de servidores (tenant UUID se gestiona por otro flujo). */
export function menuItemIsVaultAdminServersStub(item: SidebarMenuItem): boolean {
  if (item.children?.length) return false;

  const r = normalizedRoute(item);
  if (r.includes('/admin/servers')) return true;

  const lbl = normalizeMenuLabelKey(item.label ?? '').toLowerCase();
  if (lbl.includes('configuracion servidores') || lbl.includes('server configuration')) {
    return true;
  }

  const raw = (item.label ?? '').toLowerCase();
  return /configuraci[oó]n\s*(de\s*)?servidor/.test(raw);
}

function menuItemIsVaultAdminHiddenStub(item: SidebarMenuItem): boolean {
  return menuItemIsVaultAdminDashboardStub(item) || menuItemIsVaultAdminServersStub(item);
}

function stripAdminDashboardFromList(items: SidebarMenuItem[]): SidebarMenuItem[] {
  return items
    .filter((item) => !menuItemIsVaultAdminHiddenStub(item))
    .map((item) => {
      if (!item.children?.length) return item;
      const children = stripAdminDashboardFromList(item.children);
      return children.length ? { ...item, children } : { ...item, children: undefined };
    });
}

/** Quita del menú Vault entradas obsoletas (`admin/dashboard`, `admin/servers`). */
export function filterVaultAdminDashboardMenuItems(items: SidebarMenuItem[]): SidebarMenuItem[] {
  return stripAdminDashboardFromList(items);
}
